import { render, staticRenderFns } from "./TheAdminUnitTab.vue?vue&type=template&id=e21be184"
import script from "./TheAdminUnitTab.vue?vue&type=script&lang=js"
export * from "./TheAdminUnitTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports